import {
  Button,
  keyframes,
  Typography,
} from "@mui/material";
import { useModalContext } from "../../../context/ModalContext";

const HelpItem = () => {
  const { help} = useModalContext()

  const moving = keyframes`
    from {
      background:linear-gradient(rgb(255, 38, 0),rgb(40, 29, 252))
    }
    to {
      background:linear-gradient(rgb(40, 29, 252),rgb(255, 38, 0))
    }
  `;
  return (
    <Button
      onClick={() => help.open()}
      sx={{
        position: "absolute",
        bottom: "5%",
        right: "3%",
        // width: windowWidth === "small" ? "0%": "8.5%",
        maxWidth: "40%",
        background: "rgb(255, 38, 0)",
        padding: "16px 30px",
        outline: "4px solid rgb(9, 248, 200)",
        boxShadow:
          "0 0 6px inset rgb(1, 11, 9),0px 0px 16px 3px rgb(5, 36, 36)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "30px 30px 0px 30px",
        color: "whitesmoke",
        zIndex:1000,
        transition: "0.3s ease",
        animation: `${moving} 3.5s ease infinite`,
        "&:hover": {
          scale: 1.3,
          cursor: "pointer",
        },
        "@media (max-width: 600px)": {
          padding: "clamp(7px,10px,13px) clamp(15px,20px,13px)",
          bottom: "unset",
          top:"3%",
          right: "5%",
        },
      }}
    >
      <Typography sx={{ whiteSpace: "wrap", lineHeight: "18px" , }}>
        کمک بگیر!
      </Typography>
    </Button>
  );
};

export default HelpItem;
